// 收藏接口按会员共享；遍历全部分页，避免前100条以外的收藏显示为未收藏。
export async function loadAllGameFavorites(fetchPage) {
  const items = new Map()
  const pageSize = 100
  for (let pageNumber = 1; ; pageNumber++) {
    const result = await fetchPage({ pageNumber, pageSize })
    const rows = result?.data || []
    rows.forEach(item => items.set(item.id, item))
    const total = Number(result?.total)
    if (Number.isFinite(total) ? pageNumber * pageSize >= total : rows.length < pageSize) break
  }
  return [...items.values()]
}

export function favoriteGamePage(items, keyword, page, pageSize) {
  const query = keyword.trim().toLowerCase()
  const matches = items.filter(item => `${item.name || ''} ${item.gameCode || ''}`.toLowerCase().includes(query))
  return { data: matches.slice((page - 1) * pageSize, page * pageSize), total: matches.length, pageNumber: page }
}
